import { AppConfig } from "./config";

export const devConfig: AppConfig = {
  graphqlUri: "https://dev.internal.api.ecomon.no",
};
